/**
 * @file Helper for surface share links
 */

import { buildUrlFromPath } from '@@/bits/location'

export function getSectionBreakoutUrl(wallNamespace: string, sectionBreakoutIdentifier: string): string {
  return buildUrlFromPath(`${wallNamespace}/breakout/${sectionBreakoutIdentifier}`)
}

export function getSectionBreakoutPostUrl(
  wallNamespace: string,
  sectionBreakoutIdentifier: string,
  postId: number,
): string {
  return getSectionBreakoutUrl(wallNamespace, sectionBreakoutIdentifier) + `/wish/${postId}`
}
